export function chunk<T>(array: T[], chunkSize: number): T[][] {
  let chunks = []
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }
  return chunks
}